"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireWildcard(require("react"));
var _navigationHeader = _interopRequireDefault(require("../styles/navigation-header.css"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var LinkItem = exports["default"] = /*#__PURE__*/function (_PureComponent) {
  function LinkItem() {
    return _PureComponent.apply(this, arguments) || this;
  }
  (0, _inheritsLoose2["default"])(LinkItem, _PureComponent);
  var _proto = LinkItem.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      classes = _this$props.classes,
      anchorClasses = _this$props.anchorClasses,
      url = _this$props.url,
      keyHandler = _this$props.keyHandler,
      focusHandler = _this$props.focusHandler,
      children = _this$props.children,
      theme = _this$props.theme,
      clickHandler = _this$props.clickHandler;
    var addedClasses = classes.map(function (currentClass) {
      return _navigationHeader["default"][currentClass];
    });
    return /*#__PURE__*/_react["default"].createElement("li", {
      className: addedClasses.join(' ') + " menu-panel-sub-list-item",
      role: "menuitem"
    }, /*#__PURE__*/_react["default"].createElement("a", {
      className: theme.labelSmall + " " + _navigationHeader["default"].bottomLinks + " " + (anchorClasses ? anchorClasses.join(' ') : ''),
      href: url,
      onKeyDown: keyHandler,
      onFocus: focusHandler,
      onClick: clickHandler
    }, children !== undefined && children));
  };
  return LinkItem;
}(_react.PureComponent);
LinkItem.displayName = 'LinkItem';
LinkItem.defaultProps = {
  classes: []
};